import { useTranslation } from '@pos/i18n';
import { useBrandLogo } from './branding';
import './BrandLogo.scss';

/**
 * The logo for the sign-in screens: the brand's, set at head office (ADR 0106), else the platform's `logo.png` from the shared
 * public folder (served from the app's base path), which an operator replaces after deployment without a rebuild, like
 * branding.json. Nothing is shown while it loads or when neither file loads.
 */
export function BrandLogo({ className }: { className?: string }) {
  const { t } = useTranslation();
  const logo = useBrandLogo();
  if (!logo) return null;
  return (
    <img
      className={className ? `pos-brand-logo ${className}` : 'pos-brand-logo'}
      src={logo.src}
      alt={t('common.brandLogoAlt')}
      onError={logo.onError}
    />
  );
}
